import { GetCollectionsQuery } from 'generated/graphql';
import { CollectionProgram } from '../../../components/collections/collections.types';
import { factory } from '../../helpers/general';
import { RawUser } from '../../hooks/use-user';
import {
  LiteCollection,
  OTP,
  RawOTP,
  RawSubscription,
  Subscription,
} from './collections.domain';
import { ArrayItem } from '@client/new/helpers/types';
import { Row } from '@client/new/components/StandardTable/StandardTable';
import {
  faLink,
  faPencil,
  faStar,
  faTrash,
} from '@fortawesome/pro-regular-svg-icons';
import { noop } from 'lodash';
import {
  LiteWorkout,
  RawWorkout,
  FixedTitle,
} from '../collection/workouts/workouts.domain';
import { LibraryVideo } from '../../common/videos/videos.domain';
import { MuxVideo } from '@client/new/common/videos/videos.helpers';
import { BusinessModel } from '@playbook-technologies/common-enums';

export const base64Image =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAApgAAAKYB3X3/OAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAANCSURBVEiJtZZPbBtFFMZ/M7ubXdtdb1xSFyeilBapySVU8h8OoFaooFSqiihIVIpQBKci6KEg9Q6H9kovIHoCIVQJJCKE1ENFjnAgcaSGC6rEnxBwA04Tx43t2FnvDAfjkNibxgHxnWb2e/u992bee7tCa00YFsffekFY+nUzFtjW0LrvjRXrCDIAaPLlW0nHL0SsZtVoaF98mLrx3pdhOqLtYPHChahZcYYO7KvPFxvRl5XPp1sN3adWiD1ZAqD6XYK1b/dvE5IWryTt2udLFedwc1+9kLp+vbbpoDh+6TklxBeAi9TL0taeWpdmZzQDry0AcO+jQ12RyohqqoYoo8RDwJrU+qXkjWtfi8Xxt58BdQuwQs9qC/afLwCw8tnQbqYAPsgxE1S6F3EAIXux2oQFKm0ihMsOF71dHYx+f3NND68ghCu1YIoePPQN1pGRABkJ6Bus96CutRZMydTl+TvuiRW1m3n0eDl0vRPcEysqdXn+jsQPsrHMquGeXEaY4Yk4wxWcY5V/9scqOMOVUFthatyTy8QyqwZ+kDURKoMWxNKr2EeqVKcTNOajqKoBgOE28U4tdQl5p5bwCw7BWquaZSzAPlwjlithJtp3pTImSqQRrb2Z8PHGigD4RZuNX6JYj6wj7O4TFLbCO/Mn/m8R+h6rYSUb3ekokRY6f/YukArN979jcW+V/S8g0eT/N3VN3kTqWbQ428m9/8k0P/1aIhF36PccEl6EhOcAUCrXKZXXWS3XKd2vc/TRBG9O5ELC17MmWubD2nKhUKZa26Ba2+D3P+4/MNCFwg59oWVeYhkzgN/JDR8deKBoD7Y+ljEjGZ0sosXVTvbc6RHirr2reNy1OXd6pJsQ+gqjk8VWFYmHrwBzW/n+uMPFiRwHB2I7ih8ciHFxIkd/3Omk5tCDV1t+2nNu5sxxpDFNx+huNhVT3/zMDz8usXC3ddaHBj1GHj/As08fwTS7Kt1HBTmyN29vdwAw+/wbwLVOJ3uAD1wi/dUH7Qei66PfyuRj4Ik9is+hglfbkbfR3cnZm7chlUWLdwmprtCohX4HUtlOcQjLYCu+fzGJH2QRKvP3UNz8bWk1qMxjGTOMThZ3kvgLI5AzFfo379UAAAAASUVORK5CYII=';

export const rawSubscription = factory<RawSubscription>({
  id: 1,
  isVisible: true,
  influencerId: 1,
  name: 'name',
  color: 'color',
  type: 1,
  publishingBehaviour: 'publishingBehaviour',
  workoutLimit: 1,
  accessType: 'accessType',
  contentStructure: 'contentStructure',
  isLocked: true,
});

export const rawPurchase = factory<RawOTP>({
  id: 1,
  isVisible: true,
  influencerId: 1,
  name: 'name',
  color: 'color',
  type: 1,
  publishingBehaviour: 'publishingBehaviour',
  workoutLimit: 1,
  accessType: 'accessType',
  contentStructure: 'contentStructure',
  isLocked: true,
});

export const subscription = factory<Subscription>({
  ...rawSubscription({}),
  customURL: '',
});

export const otp = factory<OTP>({
  ...rawPurchase({}),
  customURL: '',
});

type MediaIntro = CollectionProgram['mediaIntro'];
export const media = factory<MediaIntro>({
  audio: null,
  cdn01: 'https://d2crdjgereq3ox.cloudfront.net/',
  image: '1685446317207_Screenshot 2023-05-29 at 21.05.05-comp.png',
  video: 'video',
  width: 874,
  height: 870,
  mimeType: 'image/png',
  source: 'https://fitner-uploads-int.s3.amazonaws.com/',
});
export const fullMedia = factory<any>({
  // TODO fix FullMedia
  duration: 1,
  audio: null,
  cdn01: 'https://d2crdjgereq3ox.cloudfront.net/',
  image: '1685446317207_Screenshot_2023-05-29_at_21.05.05-comp.png',
  video: 'video',
  width: 874,
  height: 870,
  mimeType: 'image/png',
  source: 'https://fitner-uploads-int.s3.amazonaws.com/',
  createdAt: '2023-05-30T11:32:02.162Z',
  creatorId: 1,
  fileSize: 1,
  id: 1,
  isMuted: false,
  name: 'name',
});
export const muxVideo = factory<MuxVideo>({
  id: 'some-uuid',
  influencerId: 1,
  thumbnail: 'thumbnail',
  video: 'video',
  mimeType: 'application/x-mpegURL',
  width: 1,
  height: 1,
  type: 'long',
  uploadLink: 'uploadLink',
  downloadLink: {
    low: {
      link: '',
      filesize: 1,
      width: 1,
      height: 1,
    },
    high: {
      link: '',
      filesize: 1,
      width: 1,
      height: 1,
    },
    medium: {
      link: '',
      filesize: 1,
      width: 1,
      height: 1,
    },
  },
  duration: 1,
  title: 'title',
  aspectRatio: 'aspectRatio',
  resolution: 'resolution',
  status: 'PROCESSING_FINISHED',
  fileSize: 1,
  deletedAt: null,
  createdAt: 'createdAt',
});
export const video = factory<LibraryVideo>({
  poster:
    'https://d3l5vala1x2h4r.cloudfront.net/1600886243494_100 Meter Sprint-comp-shot.jpg',
  videoSrc:
    'https://d3l5vala1x2h4r.cloudfront.net/1600886243494_100 Meter Sprint-comp.MOV',
  downloadUrl:
    'https://d3l5vala1x2h4r.cloudfront.net/1600886243494_100 Meter Sprint-comp.MOV',
  name: 'name',
  id: 1,
  creatorId: 1,
  createdAt: '2023-05-30T11:32:02.162Z',
  fileSize: 1,
  duration: 1,
  width: 874,
  height: 870,
});
export const program = factory<CollectionProgram>({
  accessType: 'exclusive',
  archivedAt: null,
  color: '6367ef',
  contentStructure: 'sequential',
  daysPerWeek: 1,
  description: '',
  difficulty: undefined,
  duration: [5, 'weeks'],
  expiresAt: null,
  faq: [],
  goal: 'Weight Loss',
  hiddenSections: {},
  id: 9394,
  inAppPurchase: 'hide',
  index: 0,
  influencerId: 4342,
  isLocked: false,
  isVisible: false,
  mediaCover: media(),
  name: 'test',
  publishingBehaviour: 'bottom',
  requiredEquipment: [],
  sessionDuration: '<30',
  tags: [],
  targetArea: [],
  testimonials: [],
  type: 0,
  mediaIntro: media(),
  publishedAt: '',
});

export const rawInfluencer = factory<RawUser['influencer']>({
  id: 4142,
  type: 1,
  firstName: 'firstName',
  lastName: 'lastName',
  salesModel: 'one-time-purchase',
  tags: [],
  profileDeepLink: 'https://playbook.test-app.link/firstname-lastname',
  mediaCover: null,
  isPaymentEnabled: true,
  paymentMethod: 1,
  stripeUserId: null,
  paypal: null,
  latestWorkout: null,
  liveStreamKey: null,
  mediaAvatar: null,
  bio: '',
  communityId: '12',
  customizations: {},
  customURL: '',
  isVisible: false,
  mode: 4,
  profileInstagram: null,
  publishedAt: null,
  tier: 2,
  title: 'Mr',
  facebookPixelId: null,
  facebookConversionApiAccessToken: null,
  ga4Configuration: null,
  tikTokConfiguration: null,
  collectionType: 'Program Only',
  productType: 'Subscription Only',
  publisheCollectionsCount: 1,
  publishedWorkoutsCount: 1,
  visibility: 'premium',
});

export const rawUser = factory<RawUser>({
  id: 4312,
  campaignFirstLogin: 2,
  username: 'username@playbookapp.io',
  role: 3,
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'username@playbookapp.io',
  token: '2844f4a9840cd698a9ab5335ba1a278e20f91077ebb3af312e3aad5f551121a7',
  tokenExpiresAt: '2024-05-30T15:06:18.539Z',
  influencerId: 4142,
  influencer: rawInfluencer(),
});

export const liteCollection = factory<LiteCollection>({
  begins: 0,
  comments: 0,
  isVisible: false,
  isLocked: false,
  rating: 0,
  completions: 0,
  title: 'Test Program',
  programId: 108,
  thumbnailUrl: '',
  type: 'published',
  customURL: '#',
  salesPageUrl:
    'https://my.integration.playbookapp.io/#/programs/test-program/108',
  index: undefined,
  profileDeepLink: 'test',
  accessType: 'exclusive',
  deeplinkUrl: undefined,
  hasChallenges: false,
  hasOngoingChallenges: false,
  challengeDeeplinkURL: 'challengeDeeplinkURL',
});

export const rawCollectionQuery = factory<GetCollectionsQuery>({
  creator: {
    customURL: null,
    businessModel: BusinessModel.Legacy,
  },
  collections: [
    {
      id: 108,
      isVisible: false,
      influencerId: 1,
      name: 'Test Program',
      type: 0,
      publishingBehaviour: 'bottom',
      contentStructure: 'sequential',
      accessType: 'exclusive',
      mediaCover: media(),
      isLocked: false,
      archivedAt: null,
      publishedAt: '2022-05-30T15:06:18.539Z',
      workouts: [
        {
          id: 1,
          statsBegins: null,
          statsComments: null,
          statsCompletions: null,
          statsRatingAverage: null,
        },
      ],
    },
  ],
  bundle: [],
});

export const rawWorkout = factory<RawWorkout>({
  __typename: 'WorkoutTiny',
  name: 'name',
  id: 1,
  statsRatingAverage: null,
  statsComments: null,
  statsBegins: null,
  statsCompletions: null,
});

export const iconTextCell = factory<ArrayItem<Row['cells']>>({
  type: 'IconText',
  value: {
    label: '-',
    icon: faStar,
  },
});

export const thumbCell = factory<ArrayItem<Row['cells']>>({
  type: 'Head',
  value: {
    title: 'Test Program',
    subtitle: [
      {
        type: 'warn',
        text: 'draft',
      },
      {
        type: 'info',
        text: 'hidden',
      },
    ],
    url: '',
  },
});

export const linkCell = factory<ArrayItem<Row['cells']>>({
  type: 'Link',
  value: {
    label: 'Open',
    icon: faLink,
    to: '/',
  },
});

export const ctaCell = factory<ArrayItem<Row['cells']>>({
  type: 'CTA items',
  value: {
    items: [
      {
        type: 'Button',
        value: {
          icon: faPencil,
          disabled: false,
          onClick: noop,
        },
      },
      {
        type: 'Button',
        value: {
          icon: faTrash,
          disabled: false,
          onClick: noop,
        },
      },
    ],
  },
});

export const liteWorkout = factory<LiteWorkout>({
  workoutId: 1,
  programId: 2,
  fixedTitle: 'Workout 1' as FixedTitle,
  orgTitle: 'Workout 1',
  type: 'draft',
  lastEditedDate: '2021-06-01T08:00:00.000Z',
  scheduledDate: '2021-06-01T08:00:00.000Z',
  rating: 3,
  begins: 1,
  completions: 1,
  comments: 1,
});
